import React, { useState, useEffect } from "react";
import About from "./About";
import Product from "./Product";
import Infrac from "./Infrac";
import Contact from "./Contact";
import Vision from "./Vision";
import Mission from "./Mission";
import Client from "./Client";

import img1 from "../images/img1.jpg";
import img2 from "../images/img2.jpg";
import img3 from "../images/img3.jpg";
import img4 from "../images/img4.jpg";
import img5 from "../images/img5.jpg";

import "../style/Home.css";

const Home: React.FC = () => {
  const images = [img1, img2, img3, img4, img5];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(false); 
      }, 1500);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div>
      <section id="hero">
        <h1 className="title">Custom And Smart Packaging Solutions</h1>
        
        <div className="img_slider">
          <img
            src={images[currentIndex]}
            alt="slider"
            className={fade ? "fade-out" : ""}
            style={{
              width: "100%",
              height: "100%",
              borderTopRightRadius: "60px",
              borderBottomRightRadius: "60px",
              objectFit: "cover",
            }}
          />
        </div>
      </section>

       <section id="about">
        <About />
      </section>

      <section id="vision">
        <Vision />
      </section>

      <section id="mission">
        <Mission />
      </section>

      <section id="product">
        <Product />
      </section>

      <section id="infrac">
        <Infrac />
      </section>

      <section id="client">
        <Client />
      </section>

      <section id="contact">
        <Contact />
      </section>
    </div>
  );
};

export default Home;

